import socket from './socket';

export default [socket];
